export interface Work {
  id: string;
  title: string;
  characterId: string;
  characterName: string;
  cover: string;
  summary: string;
  tags: string[];
  views: number;
  likes: number;
  chapters: number;
  updatedAt: string;
  status: "连载中" | "已完结";
  featured?: boolean;
  newest?: boolean;
}

export const works: Work[] = [
  {
    id: "hinata-bloom",
    title: "雏田的告白日记",
    characterId: "hinata",
    characterName: "日向雏田",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_shy_ninja_girl_with_long_dark_blue_hair_holding_a_flower_against_a_warm_sunset_village_background_romantic_gentle_atmosphere_soft_cream_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-hinata-bloom&orientation=landscape",
    summary:
      "一直暗恋着鸣人的雏田，终于鼓起勇气写下自己的心情。一次意外的任务，让她有机会与鸣人并肩同行，两颗心的距离在并肩作战中悄悄拉近。",
    tags: ["爱情", "日常", "成长"],
    views: 128400,
    likes: 9800,
    chapters: 24,
    updatedAt: "2026-08-15",
    status: "连载中",
    featured: true,
    newest: true,
  },
  {
    id: "hinata-sky",
    title: "白瞳望向的天空",
    characterId: "hinata",
    characterName: "日向雏田",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_gentle_ninja_girl_with_long_dark_indigo_hair_gazing_at_the_sky_on_a_rooftop_warm_sunset_clouds_shinobi_village_silhouette_in_background_peaceful_melancholic_mood_warm_cream_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-hinata-sky&orientation=landscape",
    summary:
      "来自日向一族的她，一直活在宗家与分家的规矩之中。当命运让她握紧拳头守护所爱之人，雏田终于抬起头，望向属于自己的天空。",
    tags: ["成长", "战斗", "励志"],
    views: 96400,
    likes: 7200,
    chapters: 18,
    updatedAt: "2026-08-10",
    status: "已完结",
    featured: true,
  },
  {
    id: "sakura-awakening",
    title: "樱色觉醒",
    characterId: "sakura",
    characterName: "春野樱",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_determined_ninja_girl_with_pink_hair_wearing_medical_gear_and_combat_attire_clenching_fist_with_resolve_warm_battlefield_sunset_background_inspirational_energy_warm_red_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-sakura-awakening&orientation=landscape",
    summary:
      "从只会哭泣的女孩，到能独当一面的医疗忍者。樱的成长之路，伴随着与同伴的羁绊和对自我的追寻，在一次次生死考验中绽放属于自己的樱色光芒。",
    tags: ["成长", "热血", "医疗"],
    views: 153200,
    likes: 12400,
    chapters: 30,
    updatedAt: "2026-08-14",
    status: "连载中",
    featured: true,
    newest: true,
  },
  {
    id: "sakura-petals",
    title: "花瓣与约定",
    characterId: "sakura",
    characterName: "春野樱",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_pink_haired_ninja_girl_and_her_team_standing_under_falling_sakura_petals_at_a_sunny_village_street_cheerful_camraderie_mood_warm_cream_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-sakura-petals&orientation=landscape",
    summary:
      "第七班的日常并不总是刀光剑影。在樱花开满的木叶街道上，樱与伙伴们许下的每一个约定，都成为支撑彼此前行的力量。",
    tags: ["日常", "友情", "轻松"],
    views: 67800,
    likes: 5100,
    chapters: 12,
    updatedAt: "2026-08-05",
    status: "已完结",
  },
  {
    id: "tsunade-legend",
    title: "传说中的医忍",
    characterId: "tsunade",
    characterName: "纲手",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_mature_blonde_ninja_woman_in_a_red_kimono_standing_authoritatively_before_a_war_torn_battlefield_warm_epic_atmosphere_heroic_pose_warm_red_gold_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-tsunade-legend&orientation=landscape",
    summary:
      "作为初代火影的孙女与传说中的三忍，纲手背负着常人难以想象的过去。当战争再度来临，她选择放下伤痛，以火影之名守护木叶的每一个人。",
    tags: ["传说", "战争", "火影"],
    views: 112500,
    likes: 9100,
    chapters: 22,
    updatedAt: "2026-08-12",
    status: "连载中",
    featured: true,
  },
  {
    id: "tsunade-gamble",
    title: "豪赌的少女时代",
    characterId: "tsunade",
    characterName: "纲手",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_young_blonde_ninja_woman_smiling_while_throwing_dice_at_a_tavern_table_warm_candlelight_atmosphere_playful_confident_mood_warm_gold_cream_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-tsunade-gamble&orientation=landscape",
    summary:
      "在成为传奇之前，纲手也曾是喜欢豪赌、有点任性又极其重情义的少女。本篇讲述她与伙伴们一同成长、逐渐扛起责任的热血过往。",
    tags: ["前传", "友情", "热血"],
    views: 80900,
    likes: 6300,
    chapters: 16,
    updatedAt: "2026-07-30",
    status: "已完结",
  },
  {
    id: "sasuke-redemption",
    title: "黑暗中的归途",
    characterId: "sasuke",
    characterName: "宇智波佐助",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_brooding_dark_haired_ninja_with_glowing_sharingan_eyes_walking_alone_on_a_moonlit_forest_path_warm_mysterious_atmosphere_dramatic_lighting_warm_dark_amber_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-sasuke-redemption&orientation=landscape",
    summary:
      "复仇的道路通向何方？当写轮眼中的仇恨逐渐冷却，佐助在黑暗中寻找属于自己的答案。这条回归之路，比想象中更加漫长。",
    tags: ["复仇", "羁绊", "心理"],
    views: 141800,
    likes: 11800,
    chapters: 27,
    updatedAt: "2026-08-13",
    status: "连载中",
    featured: true,
    newest: true,
  },
  {
    id: "sasuke-shadow",
    title: "月下之影",
    characterId: "sasuke",
    characterName: "宇智波佐助",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_ninja_with_dark_spiky_hair_standing_on_a_moonlit_rooftop_of_a_japanese_village_looking_at_the_moon_solemn_lonely_mood_warm_blue_amber_duotone_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-sasuke-shadow&orientation=landscape",
    summary:
      "每当夜幕降临，木叶的屋顶上总有一个孤独的身影。佐助在月光下思考着自己的过去与未来，那些无人知晓的心事，都藏在沉默里。",
    tags: ["心理", "孤独", "成长"],
    views: 78400,
    likes: 5900,
    chapters: 14,
    updatedAt: "2026-08-02",
    status: "已完结",
  },
  {
    id: "naruto-future",
    title: "第七代火影的日常",
    characterId: "naruto",
    characterName: "漩涡鸣人",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_cheerful_blond_ninja_in_an_orange_jumpsuit_sitting_at_a_desk_piled_with_paperwork_with_a_radiating_helicopter_leaf_symbol_on_the_hokage_mantle_warm_sunny_office_humor_mood_warm_cream_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-naruto-future&orientation=landscape",
    summary:
      "成为七代火影之后，鸣人面对的不再只是敌人，还有堆成山的文书和全村人的期待。忙碌却温暖的火影日常，在这一篇篇故事中缓缓展开。",
    tags: ["日常", "火影", "轻松", "幽默"],
    views: 136700,
    likes: 10500,
    chapters: 25,
    updatedAt: "2026-08-16",
    status: "连载中",
    featured: true,
    newest: true,
  },
  {
    id: "naruto-bonds",
    title: "永不放弃的羁绊",
    characterId: "naruto",
    characterName: "漩涡鸣人",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_blond_ninja_in_orange_jumpsuit_with_team_members_running_forward_together_toward_a_warm_sunrise_backdrop_hope_and_friendship_mood_warm_red_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-naruto-bonds&orientation=landscape",
    summary:
      "鸣人相信，成为火影的路途上最重要的不是力量，而是与伙伴们结下的羁绊。无论遇到多少次失败，他都会拍拍尘土，继续向前。",
    tags: ["热血", "友情", "励志"],
    views: 121600,
    likes: 9400,
    chapters: 20,
    updatedAt: "2026-07-28",
    status: "已完结",
    featured: true,
  },
  {
    id: "kakashi-past",
    title: "面罩下的秘密",
    characterId: "kakashi",
    characterName: "旗木卡卡西",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_masked_silver_haired_ninja_leaning_against_a_tree_reading_a_book_in_the_shade_of_a_sakura_tree_warm_calm_afternoon_light_gentle_humorous_mood_warm_cream_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-kakashi-past&orientation=landscape",
    summary:
      "总是迟到的拷贝忍者，面罩下藏着怎样的表情？卡卡西的过往、他的写轮眼来历，以及那些不为人知的温柔，都在本作中缓缓揭晓。",
    tags: ["揭秘", "日常", "师徒"],
    views: 95200,
    likes: 7100,
    chapters: 17,
    updatedAt: "2026-08-08",
    status: "连载中",
  },
  {
    id: "ino-blossom",
    title: "山中花开",
    characterId: "ino",
    characterName: "山中井野",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_cheerful_blonde_ninja_girl_with_high_ponytail_arranging_flowers_in_a_cozy_flower_shop_warm_sunny_shop_interior_happy_energetic_mood_warm_cream_pink_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-ino-blossom&orientation=landscape",
    summary:
      "在花店与忍者任务之间切换的井野，有着属于自己的节奏。她用自己的方式守护伙伴与家人，让山中一族的春天悄然绽放。",
    tags: ["日常", "友情", "轻松"],
    views: 56200,
    likes: 4200,
    chapters: 11,
    updatedAt: "2026-07-25",
    status: "已完结",
  },
  {
    id: "temari-wind",
    title: "风之国的女儿",
    characterId: "temari",
    characterName: "手鞠",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_blonde_ninja_girl_unfolding_a_large_metal_fan_on_a_sandy_desert_dune_with_a_distant_village_warm_desert_sunset_bold_confident_mood_warm_gold_sand_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-temari-wind&orientation=landscape",
    summary:
      "作为砂隐风影的长女，手鞠在风沙中长大。她用手中的三星扇和一颗勇敢的心，守护着风之国的一切，也找到了属于自己的归宿。",
    tags: ["家族", "成长", "热血"],
    views: 68900,
    likes: 5300,
    chapters: 15,
    updatedAt: "2026-08-01",
    status: "连载中",
  },
  {
    id: "shizune-care",
    title: "静音的温柔守护",
    characterId: "shizune",
    characterName: "静音",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_gentle_ninja_woman_with_dark_brown_low_ponytail_holding_medicine_preparations_in_a_warm_medical_office_with_a_pet_brown_pig_caring_serene_mood_warm_cream_green_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-shizune-care&orientation=landscape",
    summary:
      "没有惊天动地的战绩，静音的温柔却治愈了无数人。作为纲手最信赖的助手，她用细致入微的照料，守护着木叶医院里的每一个生命。",
    tags: ["医疗", "日常", "治愈"],
    views: 41800,
    likes: 3200,
    chapters: 9,
    updatedAt: "2026-07-20",
    status: "已完结",
  },
  {
    id: "team7-reunion",
    title: "第七班的假日",
    characterId: "naruto",
    characterName: "漩涡鸣人",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_ninja_team_of_four_characters_three_young_members_and_their_masked_sensei_sharing_a_meal_at_a_warm_ramen_stall_in_a_cozy_village_night_fun_camraderie_mood_warm_amber_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-team7-reunion&orientation=landscape",
    summary:
      "难得的休息日，第七班的四人围坐在拉面摊前。没有任务、没有敌人，只有热气腾腾的拉面和久违的欢声笑语，这便是最好的羁绊。",
    tags: ["日常", "第七班", "轻松"],
    views: 147300,
    likes: 12100,
    chapters: 13,
    updatedAt: "2026-08-09",
    status: "连载中",
    featured: true,
  },
  {
    id: "sakura-tsunade",
    title: "师徒的约定",
    characterId: "sakura",
    characterName: "春野樱",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_pink_haired_ninja_girl_training_under_a_mature_blonde_ninja_woman_in_a_warm_medical_training_hall_mentorship_earnest_mood_warm_cream_red_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-sakura-tsunade&orientation=landscape",
    summary:
      "拜师纲手之后，樱终于找到属于自己的道路。在严师的鞭策与慈爱中，师徒二人立下约定——要成为守护木叶的顶尖医疗忍者。",
    tags: ["师徒", "成长", "医疗"],
    views: 88600,
    likes: 6800,
    chapters: 16,
    updatedAt: "2026-08-06",
    status: "已完结",
  },
  {
    id: "sasuke-naruto",
    title: "彼此的名字",
    characterId: "sasuke",
    characterName: "宇智波佐助",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_dark_haired_ninja_and_a_blond_ninja_confronting_each_other_at_sunset_valley_silhouettes_of_brotherhood_and_rivalry_emotional_epic_mood_warm_red_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-sasuke-naruto&orientation=landscape",
    summary:
      "既是宿敌，也是最重要的朋友。佐助与鸣人之间的约定、误解与理解，跨越了无数个日夜。当两人再次面对面，他们呼唤的，是彼此的名字。",
    tags: ["羁绊", "热血", "情感"],
    views: 132500,
    likes: 10200,
    chapters: 21,
    updatedAt: "2026-08-11",
    status: "连载中",
  },
  {
    id: "hinata-sakura",
    title: "并肩的花朵",
    characterId: "hinata",
    characterName: "日向雏田",
    cover:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_two_female_ninjas_one_with_dark_indigo_long_hair_and_one_with_pink_short_hair_standing_back_to_back_ready_for_battle_warm_forest_clearing_at_dusk_girl_power_friendship_mood_warm_cream_orange_tones_clean_flat_color_anime_style_cover_high_quality&width=640&height=400&seq=naruto-cover-hinata-sakura&orientation=landscape",
    summary:
      "雏田与樱，一个是日向家的千金，一个是寻常人家的少女，却因同一位同伴而成为知己。在战场与日常中，她们学会了互相扶持、并肩绽放。",
    tags: ["友情", "日常", "成长"],
    views: 79300,
    likes: 6100,
    chapters: 15,
    updatedAt: "2026-08-03",
    status: "已完结",
  },
];

export function getWork(id: string): Work | undefined {
  return works.find((w) => w.id === id);
}